// Line icons of the mockup editor (stroke = currentColor).
import React from "react";

const Svg = ({ size = 18, strokeWidth = 2.2, children, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

const path = (d, opts) => (props) => (
  <Svg {...opts} {...props}>
    <path d={d} />
  </Svg>
);

export const AlignLeftIcon = path("M4 2v20M8 8h14M8 16h9");
export const AlignCenterXIcon = path("M12 2v20M3 8h18M7 16h10");
export const AlignRightIcon = path("M20 2v20M2 8h14M7 16h9");
export const AlignTopIcon = path("M2 4h20M8 8v14M16 8v9");
export const AlignCenterYIcon = path("M2 12h20M8 3v18M16 7v10");
export const AlignBottomIcon = path("M2 20h20M8 2v14M16 7v9");
export const FitIcon = path("M9 3v6H3M15 3v6h6M9 21v-6H3M15 21v-6h6", { size: 14 });
export const FillIcon = (props) => (
  <Svg size={14} {...props}>
    <rect x="3" y="4" width="18" height="16" rx=".5" />
    <path d="M7 11V8h4M17 13v3h-4" />
  </Svg>
);
export const ChevronLeftIcon = path("m14 6-6 6 6 6", { size: 16, strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" });
export const ChevronRightIcon = path("m10 6 6 6-6 6", { size: 16, strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" });
export const ChevronDownIcon = (props) => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    <path d="m4 6 4 4 4-4" />
  </svg>
);
export const InfoIcon = (props) => (
  <Svg size={19} strokeWidth={1.6} {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v6" />
    <circle cx="12" cy="7.5" r=".7" fill="currentColor" stroke="none" />
  </Svg>
);
export const SearchIcon = (props) => (
  <Svg size={16} strokeWidth={1.7} {...props}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="m16 16 4 4" />
  </Svg>
);
export const GridIcon = path("M4 4h16v16H4zM4 12h16M12 4v16", { size: 16, strokeWidth: 1.6 });
export const PlusIcon = path("M12 5v14M5 12h14", { size: 22, strokeWidth: 1.6, strokeLinecap: "round" });
export const CloseIcon = path("M6 6l12 12M18 6 6 18", { size: 14, strokeWidth: 1.8, strokeLinecap: "round" });
export const CheckIcon = path("m5 12.5 4.5 4.5L19 7.5", { size: 12, strokeWidth: 2.6, strokeLinecap: "round", strokeLinejoin: "round" });
export const BackIcon = path("M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11", { size: 18, strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" });
export const FolderIcon = path("M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", { size: 15, strokeWidth: 1.6 });
export const SparkIcon = path("M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4", { size: 56, strokeWidth: 1.4, strokeLinecap: "round" });
